import Vue from 'vue'
import Vuex from 'vuex'
import fileUtil from "@/util/fileUtil";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    userInfo: JSON.parse(localStorage.getItem("userInfo")),
    menuCollapse: screen.width<=748,
    isComputer:screen.width>748,
    globalSize: 'mini',
    iframeTabs:[{
      title: '首页',
      name: '30',
      url: '/business/home'
    }],
    iframeTabsActive: '30'
  },
  mutations: {
    // set
    SET_TOKEN: (state, token) => {
      state.token = token
      localStorage.setItem("token", token)
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
      localStorage.setItem("userInfo", JSON.stringify(userInfo))
    },
    REMOVE_INFO: (state) => {
      state.token = ''
      state.userInfo = {}
      localStorage.setItem("token", '')
      localStorage.setItem("userInfo", JSON.stringify(''))
    },
    CHANGE_MENU_COLLAPSE: (state)  =>{
      state.menuCollapse = !state.menuCollapse;
    },
    ADD_IFRAME_TABS:(state ,iframeView) =>{
      let menuname=iframeView.id+'';
      let menu = {
        title:iframeView.name,
        name:menuname,
        url:iframeView.page
      }

      let item = state.iframeTabs.find(item => {
        return item.name == menuname;
      });

      if(item){
        document.getElementById('iframe'+menuname).contentWindow.location.reload();
      }else{
        state.iframeTabs.push(menu)
      }

      state.iframeTabsActive=menuname
    }

  },
  getters: {
    // get
    getUser: state => {
      return state.userInfo
    }

  },
  actions: {
  },
  modules: {
  }
})
